import Typography from '@components/typography'
import styled from '@emotion/styled'

export const BookListContainer = styled.div``

export const BookGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);

  @media (max-width: 640px) {
    grid-template-columns: repeat(1, 1fr);
  }

  gap: 32px;
  padding: 20px 0;
`

export const BookCard = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: transform 0.3s ease;
  padding: 10px;

  &:hover {
    transform: scale(1.03);
  }
`

export const BookCover = styled.img`
  object-fit: cover;
  width: 100%;
  height: 100%;
  border-radius: 4px;
`
export const BookWrapper = styled.div`
  width: 100px;
  height: auto;
  border-radius: 4px;
`

export const BookTitle = styled(Typography)``

export const BookSubtitle = styled(Typography)``

export const BookCategory = styled(Typography)`
  color: #007bff;
  font-size: 14px;
  font-weight: 500;
`

export const BookActions = styled.div`
  display: flex;
  gap: 12px;
  margin-left: auto;
  padding: 10px 15px;
`

export const ActionButton = styled.span`
  cursor: pointer;
  font-weight: 500;
  transition: color 0.3s ease;

  &:hover {
    color: #0056b3;
  }
`

export const EmptyState = styled.div`
  text-align: center;
  padding: 50px;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`
